// //Redux Store
// import { configureStore } from "@reduxjs/toolkit";

// // application
// import { appSlice } from "./app/appSlice";

// // IAM
// import { iamSlice } from "./IAM/iamSlice";

// //onboard
// import onboardSlice from './onboard/onboardSlice'

// //inspection configuration 
// import inspectionConfigSlice from './onboard/inspectionConfigSlice' 

// const store = configureStore({
//   reducer: {
//     // app
//     appStore: appSlice.reducer,

//     // IAM
//     iamStore: iamSlice.reducer,

//     //onboard
//     onboardStore:onboardSlice.reducer,

//     //inspection config
//     inspectionConfigStore:inspectionConfigSlice.reducer,
//   },
// });

// // global app actions
// export const appActions = appSlice.actions;

// // IAM actions
// export const iamActions = iamSlice.actions;

// //onboard actions
//  export const onboardActions=onboardSlice.actions;

//  //inspection config actions
//  export const inspectionConfigActions=inspectionConfigSlice.actions;

// export default store;
import { configureStore } from "@reduxjs/toolkit";

// application
import { appSlice } from "./app/appSlice";

// IAM
import { iamSlice } from "./IAM/iamSlice";

// onboard
import onboardSlice from './onboard/onboardSlice';

// inspection configuration 
import inspectionConfigSlice from './onboard/inspectionConfigSlice';

// API Form
import apiFormSlice from './onboard/apiFormSlice';

const store = configureStore({
  reducer: {
    // app
    appStore: appSlice.reducer,

    // IAM
    iamStore: iamSlice.reducer,

    // onboard
    onboardStore: onboardSlice.reducer,

    // inspection config
    inspectionConfigStore: inspectionConfigSlice.reducer,

    // API Form
    apiFormStore: apiFormSlice.reducer,
  },
});

// global app actions
export const appActions = appSlice.actions;

// IAM actions
export const iamActions = iamSlice.actions;

// onboard actions
export const onboardActions = onboardSlice.actions;

// inspection config actions
export const inspectionConfigActions = inspectionConfigSlice.actions;

// API Form actions
export const apiFormActions = apiFormSlice.actions;

export default store;